import type { RouteRecordRaw } from 'vue-router'

import { registerCreativeAiMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

export const creativeAiSettingsRoutes: RouteRecordRaw[] = [
  {
    path: 'creative-ai',
    name: 'SettingsCreativeAi',
    component: () => import('./components/settings/CreativeAiSettingsPane.vue'),
    meta: {
      requiresAuth: true,
      titleKey: 'creativeAi.settings.title',
      subtitleKey: 'creativeAi.settings.description',
      navKey: 'creative-ai',
      noindex: true,
    },
    beforeEnter: () => registerCreativeAiMessages(useLocaleStore().locale),
  },
]
